<template>
    <div class="row">
        <div class="col-12 mb-1">
            <v-file-uploader :accept="['xlsx']" :value="value" value-parameter="File"></v-file-uploader>
        </div>
        <div class="col-12 mb-1" v-if="(uploadErrors || []).length">
            <h5>Yükleme Hataları</h5>
            <ul class="list-group">
                <li class="list-group-item px-50 py-25 text-danger" v-for="(e,i) in uploadErrors" :key="i">
                    {{ e }}
                </li>
            </ul>
        </div>
        <div class="col-6 mb-1">
            <select class="form-control" v-model="value.Month">
                <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
            </select>
        </div>
        <div class="col-6 mb-1">
            <select class="form-control" v-model="value.Year">
                <option v-for="y in years" :key="y" :value="y">{{y}}</option>
            </select>
        </div>
        <div class="col-md-12 text-right">
            <button class="btn btn-sm btn-flat-success" v-on:click="getSample">
                <feather-icon icon="FileIcon"></feather-icon>
                Örnek Excel
            </button>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'

export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object,
        uploadErrors:Array
    },
    data(){
        return {
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
        }
    },
    mounted(){
        this.configureYears()
    },
    methods:{
        getSample(){
            EmployeeOperationsApi.Bes.GetSampleExcel().then(res=>{
                Additional.DownloadFile(res.data, 'BES.xlsx')
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 2015
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
    },
}
</script>

<style>

</style>